import Header from '../components/UI/Header';
import Hero from '../components/Fields/Hero';
import HeroSmall from '../components/Fields/HeroSmall';
import BlockAreaRenderer from '../components/UI/BlockAreaRenderer';
import TasksBlock from '../components/Blocks/TasksBlock';
import BirthdayBlock from '../components/Blocks/BirthdayBlock';
import HighScoreBlock from '../components/Blocks/HighScoreBlock';
import FaqBlock from '../components/Blocks/FaqBlock';
import HelpBlock from '../components/Blocks/HelpBlock';
import VideoBlock from '../components/Blocks/VideoBlock';
import TimetrackerBlock from '../components/Blocks/TimetrackerBlock';
import FormBlock from '../components/Blocks/FormBlock';
import ContactsBlock from '../components/Blocks/ContactsBlock';
import OnboardingBlock from '../components/Blocks/OnboardingBlock';
import NewsTeaserBlock from '../components/Blocks/NewsTeaserBlock';
import CsodTasksBlock from '../components/Blocks/CsodTasksBlock';
import ClickableTileBlock from '../components/Blocks/ClickableTileBlock';
import MenuBlock from '../components/Blocks/MenuBlock';
import FlyoutBlock from '../components/Blocks/FlyOutBlock';
import Menu from '../components/UI/Menu';
import { CornerstoneWidgetBlock } from '../components/Blocks/cornerstone-widget-block';
import SpaceBlock from '../components/Blocks/SpaceBlock';
import { LearnerHomeWidgetBlock } from '../components/Blocks/learner-home-widget-block';

/**
 * @TODO: Get structure from backend, so we do not have to map it here again.
 * We can map Name to Component one to one, and all other props should come from the backend.
 */

// @parentRelationship: null | '*' | blockType
// null - no relation, the select parent field will not be shown
// '*' - parent can be set to any block type
// blockType - parent can be set to particular blokt type item

// @allowSelectInPage: true | false
// should block be displayed in block area for selection in the page
// in block area can be selected only root elements of the blocks, and only the items with this flag set to true

export default {
    /**
     * FAQ Group
     */
    'FaqBlock': {
        'component': FaqBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': 'FaqBlockItem',
        'width': 60,
        'allowSelectInPage':true
    },
    'FaqBlockItem': {
        'component': '',
        'props': {},
        'parentRelationship': 'FaqBlock',
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':false
    },
    /**
     * Task Group
     */
    'TasksBlock': {
        'component': TasksBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': 'TaskBlockItem',
        'width': 40,
        'allowSelectInPage':true
    },
    'TaskBlockItem': {
        'component': '',
        'props': {},
        'parentRelationship': 'TasksBlock',
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':false
    },
    /**
     * Clickable Tiles Group
     */
    'ClickableTilesBlock': {
        'component': ClickableTileBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': 'ClickableTilesBlockItem',
        'width': null,
        'allowSelectInPage':true
    },
    'ClickableTilesBlockItem': {
        'component': '',
        'props': {},
        'parentRelationship': 'ClickableTilesBlock',
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':false
    },
    /**
     * Custom
     */
    'Menu': {
        'component': Menu,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
    },
    'Header': {
        'component': Header,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    'Hero': {
        'component': Hero,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    'HeroSmall': {
        'component': HeroSmall,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    'HeroBlock': {
        'component': Hero,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    'HeroSmallBlock': {
        'component': HeroSmall,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    'BlockArea': {
        'component': BlockAreaRenderer,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null
    },
    /**
     * Others
     */
    'NewsTeaserBlock': {
        'component': NewsTeaserBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 60,
        'allowSelectInPage':true
    },
    'BirthdayBlock': {
        'component': BirthdayBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 100,
        'allowSelectInPage':true
    },
    'HighScoreBlock': {
        'component': HighScoreBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 40,
        'allowSelectInPage':true
    },
    'VideoBlock': {
        'component': VideoBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 60,
        'allowSelectInPage':true
    },
    'TimetrackerBlock': {
        'component': TimetrackerBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 40,
        'allowSelectInPage':true
    },
    'FormBlock': {
        'component': FormBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 100,
        'allowSelectInPage':true
    },
    'ContactsBlock': {
        'component': ContactsBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 40,
        'allowSelectInPage':true
    },
    'OnboardingBlock': {
        'component': OnboardingBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 60,
        'allowSelectInPage':true
    },
    'InfoBoxWidget': {
        'component': '',
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    'EmailAdministrationWidget': {
        'component': '',
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    'CsodTasksBlock': {
        'component': CsodTasksBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': 40,
        'allowSelectInPage':true
    },
    'HelpBlock': {
        'component': HelpBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': 'HelpBlockItem',
        'width': 40,
        'allowSelectInPage':true
    },
    'HelpBlockItem': {
        'component': '',
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':false
    },
    'MenuBlock': {
        'component': MenuBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    'FlyOutBlock': {
        'component': FlyoutBlock,
        'props': {},
        'parentRelationship': null,
        'childRelationship': null,
        'width': null,
        'allowSelectInPage':true
    },
    CornerstoneWidgetBlock: {
        component: CornerstoneWidgetBlock,
        props: {},
        parentRelationship: null,
        childRelationship: null,
        width: null,
        allowSelectInPage: false
    },
    SpaceBlock: {
        component: SpaceBlock,
        props: {},
        parentRelationship: null,
        childRelationship: null,
        width: null,
        allowSelectInPage: false
    },
    LearnerHomeWidgetBlock: {
        component: LearnerHomeWidgetBlock,
        props: {},
        parentRelationship: null,
        childRelationship: null,
        width: null,
        allowSelectInPage: false
    }
}



// WEBPACK FOOTER //
// ./src/frontend/definitions/fieldDefinitionKeys.js